/** The `checklist` area: the checklist rail and its lines, and the inline `#`
 *  autocomplete. Owned by the stage 2 slot components-b (docs/I18N.md §11). */
export const checklist = {
  'checklist.line.move': 'Move "{title}"',
  /** The tick's name: what a tap does to the line. */
  'checklist.tick.done': 'Done: "{title}"',
  'checklist.tick.undo': 'Undo: "{title}"',
  'checklist.tick.undoCancelled': 'Undo: "{title}" (cancelled)',
  /** The tick of a row in review, for its reviewer: Accept. */
  'checklist.tick.accept': 'Accept: "{title}"',
  /** A row in review, for its reviewer: where it stands, quietly. */
  'checklist.inReview': 'in review',
  /** What a ticked line still waits on (docs/RESOLUTION.md §2). */
  'checklist.waits.review': 'waits on the review',
  'checklist.waits.names': 'waits on {names}',
  'checklist.waits.requester': 'waits on the requester',
  /** Who else closed a line while it was on your screen. */
  'checklist.closedBy': 'by {name}',
  'checklist.locked.title': 'View only. Tap to ask the requester',
  'checklist.locked.label': 'Ask the requester to finish "{title}"',
  'checklist.retry': 'Not saved. Retry',
  'checklist.hashtag.list': 'Tags',
  /** A list's digest (docs/CHECKLIST.md §2): ticked lines and closed
   *  sub-items of all. */
  'checklist.digest': '{done} of {total}',
  'checklist.digestLabel': '{done} of {total} done',
  /** The chevron that opens a sub-item's own list beneath it. */
  'checklist.expand': 'Show the list of "{title}"',
  'checklist.collapse': 'Hide the list of "{title}"',
  /** A line's box (a line of an item's list, never an item). */
  'checklist.lineTick.done': 'Tick "{text}"',
  'checklist.lineTick.undo': 'Untick "{text}"',
  'checklist.lineLocked': 'View only: "{text}"',
  /** The line's own menu: what a tap on its text opens. */
  'checklist.lineMenu.label': 'Line "{text}"',
  'checklist.lineMenu.edit': 'Edit',
  'checklist.lineMenu.promote': 'Make this a sub-item',
  'checklist.lineMenu.indent': 'Move under the line above',
  'checklist.lineMenu.outdent': 'Move out one level',
  'checklist.lineMenu.remove': 'Remove',
  'checklist.lineEdit.label': 'Edit "{text}"',
  'checklist.promoteOpen': 'Make all open lines sub-items',
  /** A sub-item with nothing but its title, made a line of this list. */
  'checklist.itemMenu.label': 'Sub-item "{title}"',
  'checklist.itemMenu.demote': 'Make this a line',
  'checklist.itemMenu.open': 'Open',
  /** The entry at the end of an item's list. */
  'checklist.addLine': 'Add a line',
} as const;
